import WeeklyData from "Components/WeeklyData";

import type { IStepProps } from ".";

export default function Time({ data, setData }: IStepProps) {
  return (
    <WeeklyData
      data={data?.time}
      setData={(value) => setData("data", value)}
      text="سرفاصله"
      valueKey="interval"
      label="سرفاصله (دقیقه)"
      activeDays={data?.general?.working_days}
    />
  );
}
